
import { Link } from 'react-router-dom';
import "./AboutCompany.css";

const AboutCompany = () => {
 return (
        <section
     id="aboutCompany-section"
     className="common-padding"
     data-aos="fade-up"
     data-aos-duration="2000"
    >
        <div className="container">
            <div className="section-title">
                <span className="">About Us</span>
                <h2>Innovation, Trust & Excellence Since 2003</h2>
            </div>
            <div className="about-us-content">
                <p> <span className="Rohan-bold-name">Rohan Systems</span> was founded in 2003 as Rohan Enterprises and later rebranded in 2010 to expand our offerings. Over the years, we have built a strong reputation in the IT industry by consistently delivering high-quality hardware, software, networking, and security solutions to businesses and individual customers.
                   <br></br>We take pride in being an Associate Member of the Maval Association of Information Technology, upholding industry best practices and ensuring compliance with technological advancements.
                </p>
                <Link to="/about" className="know-more">
                    Know More
                </Link>
            </div>
        </div>
    </section>
 )
} 

export default AboutCompany;